/**
 * AI-generated code, moderated by lzygmanski
 */
import {useSyncExternalStore} from 'react';

const subscribe = (onStoreChange: () => void) => {
  window.addEventListener('online', onStoreChange);
  window.addEventListener('offline', onStoreChange);

  return () => {
    window.removeEventListener('online', onStoreChange);
    window.removeEventListener('offline', onStoreChange);
  };
};

const getSnapshot = () => navigator.onLine;

const getServerSnapshot = () => true;

export function useNetworkStatus() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
